import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EventsLayer from "../components/EventsLayer";

const EventsPage = () => {
  return (
    <>
      <Breadcrumb title="Events" />
      <EventsLayer />
    </>
  );
};

export default EventsPage;